export default __webpack_public_path__ + "static/media/sample_3.dab75db7.png";